<div class="control-container" [formGroup]="form" [hidden]="isHidden" [title]="control.icon ? '' : control.tooltip">
    <ng-container *ngIf="control.controlType === controlType.DateTime">
        <se-datetime-picker
            *ngIf="control.controlType === controlType.DateTime"
            class="cp-input"
            [isWithLabel]="control.isWithLabel"
            [label]="control.isWithLabel ? control.name : ''"
            [hourPlaceholder]="control.isWithLabel ? 'hh' : ''"
            [minutePlaceholder]="control.isWithLabel ? 'mm' : ''"
            [dateTime]="model"
            [disabled]="isDisabled"
            [setError]="hasError()"
            (errorStateChange)="isControlInError = $event"
            (dateTimeChange)="onDateTimeChange($event)"
        >
        </se-datetime-picker>

        <button mat-icon-button matSuffix class="se-button-no-ripple" *ngIf="control.icon" [title]="control.tooltip">
            <mat-icon>
                {{ control.icon }}
            </mat-icon>
        </button>

        <!-- Spazio fisso sotto al controllo quando se-datetime-picker non è in errore -->
        <mat-hint *ngIf="!isControlInError" translate>&nbsp;</mat-hint>
    </ng-container>

    <ng-container *ngIf="control.controlType === controlType.Time">
        <se-time-picker
            [isWithLabel]="control.isWithLabel"
            [label]="control.isWithLabel ? control.name : ''"
            [hourPlaceholder]="control.isWithLabel ? 'hh' : ''"
            [minutePlaceholder]="control.isWithLabel ? 'mm' : ''"
            [disabled]="isDisabled"
            [setError]="hasError()"
            (errorStateChange)="isControlInError = $event"
            [time]="model"
            (timeChange)="onDateTimeChange($event)"
        >
        </se-time-picker>

        <button
            mat-icon-button
            matSuffix
            style="padding: 0 0 7px 0px"
            class="se-button-no-ripple"
            *ngIf="control.icon"
            [title]="control.tooltip"
        >
            <mat-icon>
                {{ control.icon }}
            </mat-icon>
        </button>
    </ng-container>

    <mat-form-field *ngIf="control.controlType === controlType.Date" class="cp-input se-form-field" appearance="outline">
        <mat-label *ngIf="control.isWithLabel">{{ control.name }}</mat-label>

        <input
            matInput
            autocomplete="off"
            class="cp-date se-form-field-input"
            [disabled]="isDisabled"
            [errorStateMatcher]="errorStateMatcher"
            [matDatepicker]="picker"
            [formControlName]="control.id"
            [placeholder]="control.isWithLabel ? control.name : ''"
            (focusin)="onFocus()"
        />
        <mat-datepicker-toggle class="se-button-no-ripple" matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>

        <button
            mat-icon-button
            matSuffix
            class="se-button-no-ripple"
            *ngIf="control.icon"
            [title]="control.tooltip"
        >
            <mat-icon>
                {{ control.icon }}
            </mat-icon>
        </button>

        <!-- Spazio fisso sotto al controllo quando l'input non è in errore -->
        <mat-hint *ngIf="!hasError()">&nbsp;</mat-hint>
        <mat-error *ngIf="hasError()">{{ "InvalidData" | translate }}</mat-error>
    </mat-form-field>
</div>
